import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'AI Smart Campus',
    description: 'Explore a futuristic 3D university campus with AIX, your robot guide. Learn how generative AI works, use it ethically, spot its risks and become an AI-Smart Integrity Champion.',
    url: getOrigin()
}
